import { InjectionToken } from '@angular/core';

export interface IReadOnlyService {
  isReadOnly(fieldId?: string): boolean;
}

export const readOnlyServiceToken = new InjectionToken<IReadOnlyService | null>('ReadOnlyService');
